import { Divider, Stack } from "@mui/material";
import { skipWeekend } from "@root/utils/date/skipWeekend";
import { useEffect } from "react";
import { useModalOfferContext } from "../context";
import { DetailsSection } from "./detailsSection";
import { EnterpriseSection } from "./enterpriseSection";
import { StatusSection } from "./statusSection";

export const OfferFormApplicationFollowUp = () => {
  const { apply, setFollowUpDate } = useModalOfferContext();

  useEffect(() => {
    if (apply.isFollowUpGenerated && apply.contractStartDate) {
      const startDate = new Date(apply.contractStartDate);
      const nextFollowUp = new Date(startDate);
      nextFollowUp.setMonth(nextFollowUp.getMonth() + 1);
      setFollowUpDate(skipWeekend(nextFollowUp));
    }
  }, [apply.isFollowUpGenerated, apply.contractStartDate, setFollowUpDate]);

  return (
    <Stack
      direction="column"
      sx={[
        {
          gap: 2,
          pt: 1,
        },
        !apply.status ? { minHeight: 560 } : {},
      ]}
    >
      <StatusSection />
      {!!apply.status && (
        <>
          <Divider />
          <DetailsSection />
          <Divider />
          <EnterpriseSection />
        </>
      )}
    </Stack>
  );
};
